module.exports = __webpack_public_path__ + "static/media/lincoln-star.41918ecc.svg";